import { render, staticRenderFns } from "./tabbar1.vue?vue&type=template&id=cc369820&scoped=true&"
import script from "./tabbar1.vue?vue&type=script&lang=js&"
export * from "./tabbar1.vue?vue&type=script&lang=js&"
import style0 from "./tabbar1.vue?vue&type=style&index=0&id=cc369820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc369820",
  null
  
)

export default component.exports